module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAACBAMAAABF6oqGAAAAAXNSR0IB2cksfwAAABVQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgEApAAAAAd0Uk5TAKjLwSs0MS7zc74AAAATSURBVHicYxBSggEDBtdQGEgAAC7vBReszAJ+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/minus.png
// module id = 870
// module chunks = 0